import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasModulePermission } from '../utils/permissions';
import AccessDenied from '../pages/AccessDenied';

const PermissionBoundary = ({ moduleKey, action = 'view', actions = null, children }) => {
  const location = useLocation();
  const isAllowed = useMemo(() => {
    const keys = Array.isArray(moduleKey) ? moduleKey : [moduleKey];
    const actionList = Array.isArray(actions) && actions.length ? actions : [action];
    return keys.some((key) => actionList.some((item) => hasModulePermission(key, item)));
  }, [action, actions, moduleKey]);
  if (!isAllowed) {
    if (location.pathname === '/access-denied') return <AccessDenied />;
    if (children) return <AccessDenied />;
    return <Navigate to="/access-denied" replace state={{ from: location.pathname }} />;
  }
  return children;
};
export default PermissionBoundary;
